// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"D7-z"};